import { gql, useLazyQuery } from '@apollo/client';
import LOCALIZED_TEXT_FRAGMENT from 'apollo/fragments/localizedText';
import { LocalizedNewsPost } from 'apollo/localizedTypes';

const LIST_NEWS_POSTS = gql`
  query listNewsPosts($input: ListNewsPostsInput!) {
    listNewsPosts(input: $input) {
      count
      newsPosts {
        id
        title {
          ...LocalizedTextFields
        }
        publicationDate
        viewCount
        featured
        status
        readTime
        author
        contents {
          order
          content {
            ...LocalizedTextFields
          }
        }
        coverImage {
          id
          url
          type
          caption
        }
        mainImage {
          id
          url
          type
          caption
        }
        closingImages {
          id
          url
          type
          caption
        }
        newsPostRecommendations {
          id
          title {
            ...LocalizedTextFields
          }
        }
      }
    }
  }
  ${LOCALIZED_TEXT_FRAGMENT}
`;

const useListNewsPostsQuery = () => {
  return useLazyQuery<{
    listNewsPosts: {
      count: number;
      newsPosts: LocalizedNewsPost[];
    };
  }>(LIST_NEWS_POSTS, { fetchPolicy: 'no-cache' });
};

export default useListNewsPostsQuery;
